export default __webpack_public_path__ + "static/media/matches.ee4cb3fa.svg";